import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { Form, FormControl, Button } from 'react-bootstrap';

export default function Filter() {
    const history = useHistory();

    const [query, setQuery] = useState('')

    const handleQuery = (e: any) => {
        const value = e.target.value;
        setQuery(value);
    };

    const handleSubmit = (e: any) => {
        e.preventDefault();

        history.push(`/admin/dashboard/settings/programs/page/1/?search_query=${query}`);
    };

    return (
        <Form onSubmit={(e) => handleSubmit(e)} className="form-alignament">
            <Form.Group>
                <FormControl
                    placeholder="Buscar programas"
                    aria-label="search"
                    aria-describedby="search-addon"
                    className="w-100 form-control--third"
                    value={query}
                    onChange={(e) => handleQuery(e)}
                    style={{borderBottomLeftRadius: '8px', borderTopLeftRadius: '8px'}}
                />
                <Button variant="primary" type="submit" style={{width: '100px'}}>
                    Buscar
                </Button>
            </Form.Group>
        </Form>
    )
}
